import React from 'react';
import { Box, Typography } from '@mui/material';

const EventsAlarms: React.FC = () => (
  <Box sx={{ color: '#fff', p: 4 }}>
    <Typography variant="h4">Events & Alarms</Typography>
    <Typography sx={{ mt: 2 }}>Events & Alarms page (stub)</Typography>
  </Box>
);

export default EventsAlarms;
